<template>
  <div>
    <div class="home-banner">
      <img :src="pictureUrl" alt srcset @click="See" />
    </div>
    <!-- 图标导航 -->
    <div class="home-content clearfix">
      <div
        class="home-content-list"
        v-for="(item, index) in pageConfigList"
        :key="index"
        @click="handleGoPage(item.name)"
      >
        <!-- 隐藏产品充值 -->
        <!-- item.name == '产品充值'? icon4: -->
        <img
          :src="
            item.name == '问题报修'
              ? icon1
              : item.name == '业务咨询'
              ? icon2
              : item.name == '常见问题'
              ? icon3
              : item.name == '产品充值'
              ? icon4
              : item.name == '人员核实'
              ? icon5
              : item.name == '用户信息'
              ? icon6
              : item.name == '人员培训'
              ? icon7
              : item.name == '人员考核'
              ? icon8
              : item.name == '网吧管理'
              ? icon9
              : item.name == '工单处理'
              ? icon10
              : item.name == '巡检工作'
              ? icon11
              : item.name == '知识库'
              ? icon12
              : item.name == '客户管理'
              ? icon13
              : item.name == '抽奖活动'
              ? icon14
              : item.name == '我的积分'
              ? icon15
              : ''
          "
          alt
          srcset
        />
        <div class="home-content-list-text">{{ item.name }}</div>
      </div>
    </div>
    <!-- <div class="btn" @click="handleRemoveClick">退出登录</div> -->
  </div>
</template>
<script>
// @/images/cpcz@2x.png
import { bannerImg, IndexList, RichScan } from "@/api/index";
import { drawrule } from "@/api/draw.js";
import { Button } from "vant";
import { Toast } from "vant";
import wx from "weixin-js-sdk";
import { format } from "path";
import { register } from "@/api/login";
export default {
  name: "HelloWorld",
  components: {
    vButton: Button,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      pictureUrl: "",
      bannerLink: "",
      pageConfigList: [],
      pagePictureList: [],
      icon1: require("@/images/wentibaoxiu.png"),
      icon2: require("@/images/yewuzixun.png"),
      icon3: require("@/images/changjianwenti.png"),
      icon4: require("@/images/chanpingchongzhi.png"),
      icon5: require("@/images/renyuanheshi.png"),
      icon6: require("@/images/yonghuxinxi.png"),
      icon7: require("@/images/yewuzixun.png"),
      icon8: require("@/images/renyuankaohe.png"),
      icon9: require("@/images/wangbaguanli.png"),
      icon10: require("@/images/gongdanchuli.png"),
      icon11: require("@/images/xunjiangongzuo.png"),
      icon12: require("@/images/zhishiku.png"),
      icon13: require("@/images/kehuguanli.png"),
      icon14: require("@/images/huodong.png"),
      icon15: require("@/images/jifen.png"),
    };
  },
  mounted() {
    // 获取从选择网吧页面过来的网吧id再次存储一下
    if (sessionStorage.getItem("internetBarId")) {
      let internetBarId = sessionStorage.getItem("internetBarId");
      this.$cookies.set("internetBarId", internetBarId);
    }
    this.requestBannerImg();
    this.requestIndexList();
    this.requestRichScan();
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.fun, false); //false阻止默认事件
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.fun, false); //false阻止默认事件
  },
  methods: {
    fun() {
      wx.closeWindow();
    },

    // 获取轮播图
    requestBannerImg() {
      bannerImg().then((res) => {
        console.log(res);
        this.pictureUrl = res.data[0].pictureUrl;
        this.bannerLink = res.data[0].link;
      });
    },
    See() {
      window.location.href = this.bannerLink;
    },
    // 获取配置列表
    requestIndexList() {
      //  获取是否是运维端还是场所端
      let type = JSON.parse(sessionStorage.getItem("loginInfo")).role;
      IndexList({ type: type }).then((res) => {
        // 获取轮播图片
        let pagePictureList = res.data.pagePictureList;
        this.pagePictureList = pagePictureList;
        // 获取配置列表
        let pageConfigList = res.data.pageConfigList;
        this.pageConfigList = pageConfigList;
      });
    },

    //点击人员核实进入扫一扫
    requestRichScan() {
      let href = location.href.split("#")[0];
      RichScan({ url: href }).then((res) => {
        //console.log(res);
        if (res.code == 200) {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端//alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: ["scanQRCode"], // 必填，需要使用的JS接口列表
          });
        }
      });
    },
    // 点击二维码
    qrcode() {
      let _this = this;
      wx.ready(function() {
        wx.checkJsApi({
          jsApiList: ["scanQRCode"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
          success: function(res) {
            if (res.checkResult.scanQRCode === true) {
              wx.scanQRCode({
                // 微信扫一扫接口
                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                success: function(res) {
                  const getCode = res.resultStr; // 当needResult 为 1 时，扫码返回的结果'
                  _this.$router.push({
                    path: "/personnelverify",
                    query: {
                      getCode: getCode,
                    },
                  });
                },
              });
            } else {
              Toast("抱歉，当前客户端版本不支持扫一扫");
            }
          },
        });
      });
    },
    // 跳转路由
    handleGoPage(name) {
      switch (name) {
        case "问题报修":
          this.$router.push({ path: "/pblmwarranty" });
          break;
        case "常见问题":
          this.$router.push({ path: "/problems" });
          break;
        case "产品充值":
          this.$router.push({ path: "/productpay" });
          break;
        case "业务咨询":
          this.$router.push({ path: "/consultrecords" });
          break;
        case "人员核实":
          this.qrcode();
          break;
        case "用户信息":
          this.$router.push({ path: "/perosonneluserinfo" });
          break;
        case "人员培训":
          this.$router.push({ path: "/personnelinspection" });
          break;
        case "人员考核":
          this.$router.push({ path: "/personnelassess" });
          break;
        case "网吧管理":
          this.$router.push({ path: "/netbarsoftware" });
          break;
        case "工单处理":
          this.$router.push({ path: "/workorderprocess" });
          break;
        case "巡检工作":
          this.$router.push({ path: "/inspectionrecords" });
          break;
        case "知识库":
          this.$router.push({ path: "/base" });
          break;
        case "客户管理":
          this.$router.push({ path: "/customersearch" });
          break;
        case "抽奖活动":
          // this.$router.push({ path: "/drawactivity" });
		  this.$router.push({ path: "/draw_menu" });
          // this.getData(this.$cookies.get("internetBarId"));
          break;
        case "我的积分":
          this.$router.push({ path: "/integral" });
          break;
      }
    },
    async getData(internetBarId) {
      try {
        const data = await drawrule({ internetBarId });
        console.log(data);
        if (data.data == null) {
          Toast('暂无可参与的抽奖活动!');
        } else {
          this.$router.push({ path: "/draw_menu" });
        }
      } catch (e) {}
    },
    handleRemoveClick() {
      sessionStorage.removeItem("loginInfo");
      this.$router.push({
        path: "/login",
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home-banner {
  width: 349px;
  height: 150px;
  margin: 0 auto;
  img {
    width: $percentage;
    height: $percentage;
    border-radius: 10px;
  }
}
// 图标导航
.home-content {
  width: $percentage;
  height: $percentage;
  padding: 10px 5px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  .home-content-list {
    width: 33.33333%;
    height: 100px;
    img {
      width: 60px;
      height: 60px;
    }
    .home-content-list-text {
      font-size: 13px;
      color: #333333;
      text-align: center;
    }
  }
}
.btn {
  width: 350px;
  height: 44px;
  background: -webkit-linear-gradient(left, #05aefc, #008cff);
  margin: 0 auto;
  border-radius: 22px;
  font-size: 16px;
  color: $white-color;
  line-height: 44px;
  margin: 20px auto;
}
</style>
